import { contentGeneratorConfigPopulatedSchema } from "@redotech/redo-marketing-templates-common/content-generator-config/content-generator-config-definition";
import * as z from "zod";

export const getContentGeneratorConfigPopulated = {
  name: "getContentGeneratorConfigPopulated" as const,
  input: z.object({ configId: z.string() }),
  output: contentGeneratorConfigPopulatedSchema,
};
